import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import { red } from '@mui/material/colors';

const RedButton = styled(Button)(({ theme }) => ({
  color: `${theme.palette.getContrastText(red[500])} !important`,
  backgroundColor: `${red[500]} !important`,
  '&:hover': {
    backgroundColor: `${red[700]} !important`,
  },
}));

export default RedButton;
